import { render, staticRenderFns } from "./BuildingsTable.vue?vue&type=template&id=e49dc250&"
import script from "./BuildingsTable.vue?vue&type=script&lang=js&"
export * from "./BuildingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports